import * as uuid from "uuid";

/**
 *
 * @returns {string} base 16 of random strings
 */

export function genUUID(): string {
  return uuid.v4();
}
